import { useState, useEffect } from 'react'

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query)

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQueryList.addEventListener('change', handleMediaQueryChange)

    // Cleanup the event listener when the component unmounts
    return () => {
      mediaQueryList.removeEventListener('change', handleMediaQueryChange)
    }
  }, [query])

  // Usage
  // const isSmallScreen = useMediaQuery('(max-width: 768px)')
  // {isSmallScreen ? 'Small screen' : 'Not a small screen'}

  return matches
}
